import { render, staticRenderFns } from "./bbgl-dfrc.vue?vue&type=template&id=6fde044b&scoped=true"
import script from "./bbgl-dfrc.vue?vue&type=script&lang=js"
export * from "./bbgl-dfrc.vue?vue&type=script&lang=js"
import style0 from "./bbgl-dfrc.vue?vue&type=style&index=0&id=6fde044b&prod&lang=scss"
import style1 from "./bbgl-dfrc.vue?vue&type=style&index=1&id=6fde044b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fde044b",
  null
  
)

export default component.exports